import {Component, Input, OnInit} from '@angular/core';
import {Contract, SALESHUB_CONTRACT_STATUS} from '../../shared/domain/contract';
import {ItemSummaryItemSummaryService} from '../../shared/asset/item-summary-item-summary.service';

@Component({
  selector: 'lib-item-summary-contract-card',
  templateUrl: './contract-card.component.html',
  styleUrls: ['../opportunity-contract-card/opportunity-contract-card.component.scss']
})
export class ContractCardComponent implements OnInit {

  @Input() itemId: number;
  @Input() itemSummaryService: ItemSummaryItemSummaryService;

  contract: Contract;
  contractBackground = 'card-body h-100 background-green';
  contractCardSubTitleText = 'card-subtitle text-white';
  contractCardtitleText = 'card-title text-white';
  contractDocstatus = 'badge badge-green';
  contractStateStyle = 'badge badge-green';

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.itemSummaryService.getContractInfo(this.itemId)
      .subscribe(contract => {
        this.contract = contract;
        this.getContractStateStyle();
      });
  }

  getContractDocStatus() {
    if (this.contract.contractDocumentStatus) {
      if (this.contract.contractDocumentStatus === 'Not Sent') {
        this.contractBackground = 'card-body h-100  background-yellow';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-yellow';
      } else if (this.contract.contractDocumentStatus === 'Sent' || this.contract.contractDocumentStatus === 'Delivered') {
        this.contractBackground = 'card-body h-100  background-orange';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-orange';
      } else if (this.contract.contractDocumentStatus === 'Completed') {
        this.contractBackground = 'card-body h-100  background-green';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-green';
      } else if (this.contract.contractDocumentStatus === 'Declined' || this.contract.contractDocumentStatus === 'Voided') {
        this.contractBackground = 'card-body h-100  background-red';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-red';
      } else {
        this.contractBackground = 'card-body h-100  background-grey';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-grey';
      }
    } else {
      this.contractDocstatus = 'badge badge-grey';
    }
  }

  private getContractStateStyle() {
    if (this.contract.contractState) {
      if (this.contract.contractState === SALESHUB_CONTRACT_STATUS.inProgress) {
        this.contractStateStyle = 'badge badge-csinprogress';
      } else if (this.contract.contractState === SALESHUB_CONTRACT_STATUS.readyForSale) {
        this.contractStateStyle = 'badge badge-csinready';
      } else if (this.contract.contractState === SALESHUB_CONTRACT_STATUS.pendingFinalized) {
        this.contractStateStyle = 'badge badge-csinpending';
      } else if (this.contract.contractState === SALESHUB_CONTRACT_STATUS.finalized) {
        this.contractStateStyle = 'badge badge-csinfinalized';
      } else if (this.contract.contractState === SALESHUB_CONTRACT_STATUS.cancelled) {
        this.contractStateStyle = 'badge badge-csincancelled';
      } else {
        this.contractStateStyle = 'badge badge-csothers';
      }
    } else {
      this.contractStateStyle = 'badge badge-grey';
    }
  }
}
